import { render, staticRenderFns } from "./paIndexModelManage.vue?vue&type=template&id=6f3cc94f&"
import script from "./paIndexModelManage.vue?vue&type=script&lang=js&"
export * from "./paIndexModelManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports